import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./services/feature-toggle-adapter";
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
import App from "./app";

const container = document.getElementById("root");
const root = createRoot(container as Element);

console.log(window.location.toString());

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker should only be registered in production builds
// In development, it causes page reloads when the app returns from background
// because checkValidServiceWorker() can't find service-worker.js and triggers reload
if (import.meta.env.MODE === "production") {
  serviceWorkerRegistration.register();
} else {
  // Unregister any existing service worker in development to prevent issues
  serviceWorkerRegistration.unregister();
}

reportWebVitals();
